<template>
    <u-btn-outlined-tile-arrow v-bind="$attrs" color="primary" class="v-size--xx-large" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-outlined-tile-arrow>
</template>

<script>
import UBtnOutlinedTileArrow from "@/components/publish/styles/buttons/u-btn-outlined-tile-arrow.vue";

export default {
    props: {},
    components: {
        UBtnOutlinedTileArrow,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
